module.exports = __webpack_public_path__ + "img/htkj_02.c0fa1ca6.jpg";